export default __webpack_public_path__ + "static/media/NotoSerif-Bold.0cf73916.eot";